import { Chain, ChainID } from '@ankr.com/chains-list';
import { t } from '@ankr.com/common';

import { ChainPageSkeleton } from 'modules/chains/components/ChainPageSkeleton';
import { useAppSelector } from 'store/useAppSelector';
import {
  selectBlockchainsLoadingStatus,
  selectNodesDetailsLoadingStatus,
  selectPublicChainById,
} from 'modules/chains/store/selectors';

interface PublicChainPageLoaderProps {
  Component: React.FC<{ chain: Chain }>;
  chainID: ChainID;
}

export const PublicChainPageLoader = ({
  Component,
  chainID,
}: PublicChainPageLoaderProps) => {
  const isLoadingChains = useAppSelector(selectBlockchainsLoadingStatus);
  const isLoadingNodes = useAppSelector(selectNodesDetailsLoadingStatus);
  const isLoading = isLoadingChains || isLoadingNodes;

  const publicChain = useAppSelector(state =>
    selectPublicChainById(state, chainID),
  );

  if (isLoading) {
    return <ChainPageSkeleton />;
  }

  if (!publicChain) {
    throw new Error(t('chain-item.not-found'));
  }

  return <Component chain={publicChain} />;
};
